import styled, { css } from "styled-components";

export const CopyableTextAreaHeaderContainer = styled.div`
  padding: 6px 10px 7.5px 10px;
  margin-left: -10px;
  border-radius: 10px 10px 0 0;
  top: 0px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 19000;

  &.textarea-header.prose-actions {
    padding: 0;
    margin-left: 20px;
    z-index: 1000;
  }

  &.textarea-header.commands-actions {
    gap: 10px;
    .left-container {
      flex-shrink: 3;
      .title {
        flex-shrink: 1;
      }
      .help {
        flex-shrink: 0;
      }
    }

    .right-container {
      count {
        flex-shrink: 2;
      }
    }
  }

  ${(props) =>
    props.isInChapter &&
    css`
      /* Styles when isInChapter is true */
      top: 40px;
    `}

  .chapter-header {
    top: 40px;
  }

  svg {
    position: relative;
  }

  .right-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-shrink: 1;
    min-width: 0;

    &.footer {
      gap: 16px;
    }

    a {
      display: inline-block;
      color: var(--grey-0);
      padding: 6px 6px 4px 6px;
      border-radius: 8px;
    }

    button {
      margin: 0 !important;
      border-radius: 10px !important;
      height: 38px !important;
      display: flex;
      align-items: center;
      gap: 6px;

      svg {
        path {
          fill: var(--cta-text-color);
        }
        position: relative;
      }
    }

    #button-generate-prose {
      p {
        font-size: 16px;
      }
    }

    button:disabled {
      background: var(--primary-cta-light) !important;
    }

    button.pause {
      padding: 9px 14px 9px 8px !important;
      svg {
        width: 24px;
        height: 24px;
        rect {
          fill: var(--cta-text-color);
        }
      }

      .labels {
        display: flex;
        flex-direction: column;
        .label {
          font-size: 14.8px;
          font-weight: 500;
        }

        .sublabel {
          font-size: 9px;
          font-weight: 400;
        }
      }
    }

    button.generate,
    button.continue {
      display: flex;
      padding: 9px 14px 9px 8px !important;
      border: none;
    }

    button.continue {
      align-items: center;
    }

    button.generate {
      svg {
        width: 24px;
        height: 24px;
      }
    }

    button.scene-directions {
      margin-left: 10px !important;
    }

    button.prose-after-preflight {
      text-align: left;
      min-width: 150px;
      .labels {
        .label {
          font-size: 14px;
          font-weight: 500;
        }
        .words {
          font-size: 10px;
          font-weight: 600;
          min-width: 120px;
        }
      }
    }

    .count {
      font-size: 14px;
      line-height: 1.3;
      font-weight: 500;
      color: var(--grey-0);
      opacity: 0.6;
      margin-right: 8px;
      text-align: right;
    }

    .copy {
      position: relative;

      svg {
        height: 27px;
        width: 27px;
      }

      &:before {
        opacity: 0;
        transition: opacity 0.2s linear;
        transition-delay: 0.2s;
        position: absolute;
        content: "";
      }
      &:hover {
        &:before {
          content: "Copy";
          text-transform: none;
          position: absolute;
          opacity: 1;
          left: 50%;
          transform: translate(-50%, 10px);
          line-height: 20px;
          height: 20px;
          font-weight: 500;
          top: 33px;
          padding: 3px 8px;
          background-color: var(--grey-0);
          color: var(--context-menu-text);
          border-radius: 6px;
          font-size: 12px;
          white-space: nowrap;
          z-index: 1000;
        }
      }
    }

    .history {
      position: relative;

      svg {
        height: 24px;
        width: 24px;
      }

      &:before {
        opacity: 0;
        transition: opacity 0.2s linear;
        transition-delay: 0.2s;
        position: absolute;
        content: "";
      }

      &:hover {
        &:before {
          content: "History";
          text-transform: none;
          position: absolute;
          opacity: 1;
          left: 50%;
          transform: translate(-50%, 10px);
          line-height: 20px;
          height: 20px;
          font-weight: 500;
          top: 33px;
          padding: 3px 8px;
          background-color: var(--grey-0);
          color: var(--context-menu-text);
          border-radius: 6px;
          font-size: 12px;
          white-space: nowrap;
          z-index: 1000;
        }
      }
    }
  }

  .left-container {
    display: flex;
    gap: 6px;
    align-items: center;
    min-width: 0;

    &.small {
      gap: 0;
    }

    .chevron-wrapper {
      display: flex;
      align-items: center;
    }

    .collapse-chevron {
      cursor: pointer;
      width: 20px;
      height: 20px;
      transition: transform 0.2s ease;

      path {
        fill: var(--grey-2);
      }
    }

    .rotated-chevron {
      transform: rotate(-90deg);
    }

    a {
      display: inline-block;
      color: var(--grey-0);
      padding: 3px 0;
      border-radius: 5px;
    }

    .title {
      font-weight: 500;
      font-size: 20px;
      color: var(--grey-0);
      display: flex;
      align-items: center;
      min-width: 0;
      overflow: hidden;

      .title-label {
        flex: 0 0 auto;
      }

      svg {
        width: 30px;
        height: 30px;
        flex: 0 0 auto;
        path {
          fill: var(--grey-0);
        }
        circle {
          fill: var(--grey-0);
        }
        rect {
          fill: var(--grey-0);
        }

        // typewriter svg is a little different
        // so it gets special treatment
        &.generator-icon {
          width: 24px;
          height: 24px;
          margin-right: 7px;
          rect {
            fill: none;
          }
        }
      }
    }

    .title-large {
      font-size: 18px;
      font-weight: 500;
    }

    .help {
      line-height: 21px;
      border-radius: 25px;
      height: 21px;
      width: 21px;
      position: relative;
      color: var(--menu-color-fullscreen);
      display: block;
      padding: 0;
      font-weight: bold;
      font-size: 17px;
      text-align: center;
      background: var(--grey-2);
    }
    h2 {
      margin-bottom: 0 !important;
      font-size: 20px !important;
      font-weight: 500 !important;
    }
  }
`;
